<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper" v-if="!isEditing || Object.keys(userData).length">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <!-- Settings Menu -->
          <settings-tabs></settings-tabs>
          <!-- /Settings Menu -->

          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="contact-head">
                <div class="row align-items-center">
                  <div class="col-sm-6">
                    <ul class="contact-breadcrumb">
                      <li>
                        <router-link to="/users/users-list"><i class="ti ti-arrow-narrow-left"></i>List</router-link>
                      </li>
                      <!-- <li>{{ isEditing ? 'Edit User' : 'Create New User' }}</li> -->
                    </ul>
                  </div>
                </div>
              </div>
              <!-- Company Settings -->
              <div class="card">
                <div class="card-body settings-form">
                  <div class="row">
                    <div class="col-md-5 col-sm-4">
                      <h4>{{ isEditing ? 'Edit User' : 'Create User' }}</h4>
                    </div>
                    <div class="col-md-7 col-sm-8">
                    </div>
                  </div>
                  <Form @submit="registerUser" :validation-schema="schema">
                    <div class="settings-sub-header">
                    </div>
                    <div class="profile-details">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-wrap">
                            <div class="profile-upload">
                              <div class="profile-upload-img">
                                <span v-if="!imagePreview"><i class="ti ti-photo"></i></span>
                                <img v-if="imagePreview" :src="imagePreview" class="img-fluid" />
                                <button v-if="imagePreview" type="button" class="profile-remove" @click="removeImage">
                                  <i class="feather-x"></i>
                                </button>
                              </div>
                              <div class="profile-upload-content">
                                <label class="profile-upload-btn">
                                  <i class="ti ti-file-broken"></i> Upload File
                                  <input type="file" class="input-img" @change="handleImageUpload" />
                                </label>
                                <p>
                                  Upload User Image (In jpeg, png, jpg).
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">First Name <span class="text-danger">*</span></label>
                            <Field name="first_name" as="input" type="text" class="form-control"
                              v-model="form.first_name" @keyup="handleInitials" />
                            <ErrorMessage name="first_name" class="text-danger" />
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Last Name</label>
                            <Field name="last_name" as="input" v-model="form.last_name" type="text" class="form-control"
                              @keyup="handleInitials" />
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Initials</label>
                            <Field name="initial" as="input" v-model="form.initials" type="text" class="form-control"
                              readonly style="background-color: #e9ecef;" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['initials'] && apiErrors['initials'].length">{{
                                apiErrors['initials'][0] }}</span>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Email <span v-if="!isEditing"
                                class="text-danger">*</span></label>
                            <Field name="email" as="input"
                            :disabled="isEditing && user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'" v-model="form.email"
                              type="email" class="form-control" />
                            <ErrorMessage name="email" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['email'] && apiErrors['email'].length">{{
                                apiErrors['email'][0] }}</span>
                          </div>
                        </div>
                        <!-- <div class="col-md-3">
                        <div class="form-wrap">
                          <label class="col-form-label">Login Name</label>
                          <input v-model="form.login_name" type="text" class="form-control" />
                          <span class="text-danger" v-if="apiErrors && apiErrors['login_name'] && apiErrors['login_name'].length">{{ apiErrors['login_name'][0] }}</span>
                        </div>
                      </div> -->
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Title</label>
                            <input v-model="form.title" type="text" class="form-control" />
                          </div>
                        </div>
                        <!-- <div class="col-md-3">
                        <div class="form-wrap">
                          <label class="col-form-label">Login by sms code</label>
                          <select id="loginBySms" class="form-select" v-model="form.login_by_sms_code">
                            <option value="no">-----No-----</option>
                            <option v-for="source in loginSmsCode" :key="source" :value="source">
                              {{ source }}
                            </option>
                          </select>
                        </div>
                      </div> -->
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Telephone</label>
                            <Field name="telephone" ref="phoneInput" as="input" v-model="form.telephone" type="text"
                              class="form-control" />
                            <ErrorMessage name="telephone" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['telephone'] && apiErrors['telephone'].length">{{
                                apiErrors['telephone'][0] }}</span>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Mobile</label>
                            <Field name="phone_number" as="input" v-model="formattedTelephone" type="text"
                              class="form-control" />
                            <ErrorMessage name="phone_number" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['phone_number'] && apiErrors['phone_number'].length">{{
                                apiErrors['phone_number'][0] }}</span>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Password <span v-if="!isEditing"
                                class="text-danger">*</span></label>
                            <Field id="password" name="password" as="input" v-model="form.password" type="password"
                              class="form-control" autocomplete="new-password" />
                            <ErrorMessage name="password" class="text-danger" />
                            <span class="text-danger"
                              v-if="isEditing && apiErrors && apiErrors['password'] && apiErrors['password'].length">{{
                                apiErrors['password'][0] }}</span>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Confirm Password <span v-if="!isEditing"
                                class="text-danger">*</span></label>
                            <Field id="password_confirmation" name="password_confirmation" as="input"
                              v-model="form.password_confirmation" type="password" class="form-control" />
                            <ErrorMessage name="password_confirmation" class="text-danger" />
                          </div>
                        </div>
                      </div>

                      <!-- <div class="col-md-3">
                        <div class="form-wrap">
                          <label class="col-form-label">Use available status</label>
                          <select id="availStatus" class="form-select" v-model="form.use_available_status">
                            <option value="">-----Select-----</option>
                            <option v-for="source in availStatus" :key="source" :value="source">
                              {{ source }}
                            </option>
                          </select>
                        </div>
                      </div> -->

                      <div class="row" v-for="(role, index) in form.roles_data" :key="index">

                        <!-- Access Level -->
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Access level</label>
                            <Field as="select" :name="`roles_data[${index}].role`" class="form-select"
                              v-model="role.role" @change="fetchResponsibles('role', index)">
                              <option value="">-----Select-----</option>
                              <option v-for="item in roles" :key="item.key" :value="item.key">
                                {{ item.value }}
                              </option>
                            </Field>
                            <ErrorMessage :name="`roles_data[${index}].role`" class="text-danger" />
                          </div>
                        </div>

                        <!-- Territories -->

                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Territories</label>
                            <!-- <multiselect v-model="role.territory_ids" :options="territories" track-by="id" label="name"
                              :multiple="true" placeholder="Select..." /> -->
                            <Field :name="`roles_data[${index}].territory_ids`" v-model="role.territory_ids"
                              class="form-select">
                              <multiselect v-model="role.territory_ids" :options="getAvailableTerritories(index)"
                                track-by="id" label="name"
                                :multiple="role.role === 'territory_manager' || role.role === 'cm_responsible'"
                                placeholder="Select..." @update:modelValue="fetchResponsibles('ter', index)" />
                              <!-- <multiselect v-model="role.territory_ids" :options="territories" track-by="id"
                                label="name"
                                :multiple="role.role === 'territory_manager' || role.role === 'cm_responsible'"
                                placeholder="Select..." @update:modelValue="fetchResponsibles('ter', index)">
                              </multiselect> -->
                            </Field>
                            <ErrorMessage :name="`roles_data[${index}].territory_ids`" class="text-danger" />
                          </div>
                        </div>

                        <!-- Assigned Manager -->
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Assigned Manager</label>
                            <select class="form-select" v-model="role.assigned_manager">
                              <option value="">-----Select-----</option>
                              <option v-for="res in responsibleUsers[index]" :key="res.id" :value="res.id">
                                {{ res.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                          <!-- Remove Button On All Rows Except When Only One Row Exists -->
                          <div class="col-md-1 d-flex align-items-center" v-if="form.roles_data.length > 1">
                          <button type="button" class="mt-2 cross-btn" @click="removeRole(index)">
                            <!-- Remove -->
                            <i data-v-505522fa="" class="ion-close-round text-danger" data-bs-toggle="tooltip"
                              title="Delete Row"></i>
                          </button>
                        </div>

                        <!-- Add Button Only On Last Row -->
                        <div class="col-md-1 d-flex align-items-center"
                          v-if="index === form.roles_data.length - 1 && form.roles_data.length < territories.length &&  canAddRole ">
                          <button type="button" class="btn btn-primary mt-2" @click="addRole">
                            <!-- ➕ Add  -->
                            <i class="fas fa-plus text-white" data-bs-toggle="tooltip" title="Add Row"></i>
                          </button>
                        </div>

                        <!-- <div class="col-md-1 d-flex align-items-center" v-else>
                        </div> -->

                      

                      </div>


                      <div class="profile-address pb-3" v-if="permissionArray.length > 0">
                        <div class="settings-sub-header pb-1">
                          <h6>Permissions</h6>
                          <!-- Select All Checkbox -->
                          <div class="form-check my-2">
                            <input type="checkbox" class="form-check-input" id="selectAll" :checked="allSelected"
                              @change="toggleSelectAll" />
                            <label class="form-check-label" for="selectAll">Select All</label>
                          </div>
                        </div>

                        <div class="row m-0">
                          <div v-for="permission in permissionArray" :key="permission.name"
                            class="col-12 col-xs-12 col-md-2 mb-3 form-check">
                            <input type="checkbox" class="form-check-input" :id="permission.name"
                              :value="permission.name" v-model="form.permissions" />
                            <label class="form-check-label" :for="permission.name">
                              {{ permission.display_name }}
                            </label>
                          </div>
                        </div>
                      </div>
                      
                      <!-- API Access Settings -->
                      <div class="profile-address pb-3">
                        <div class="settings-sub-header pb-1">
                          <h6>API Access Settings</h6>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-wrap">
                              <label class="col-form-label">
                                Allowed MPAN API Calls
                                <i class="ti ti-info-circle" 
                                   data-bs-toggle="tooltip" 
                                   data-bs-placement="top"
                                   title="Maximum number of MPAN API calls allowed for this user. Default: 0 (no calls allowed)."></i>
                              </label>
                              <Field 
                                name="allowed_mpan_api_calls" 
                                as="input" 
                                type="number" 
                                class="form-control"
                                v-model.number="form.allowed_mpan_api_calls"
                                min="0"
                                step="1"
                                placeholder="0" />
                              <ErrorMessage name="allowed_mpan_api_calls" class="text-danger" />
                              <small class="form-text text-muted">
                                Maximum number of MPAN API calls allowed for this user. Default: 0 (no calls allowed).
                              </small>
                              <span class="text-danger"
                                v-if="apiErrors && apiErrors['allowed_mpan_api_calls'] && apiErrors['allowed_mpan_api_calls'].length">{{
                                  apiErrors['allowed_mpan_api_calls'][0] }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /API Access Settings -->
                      
                      <!-- <div class="row align-items-center my-3">
                      <div class="col-md-2">
                        <h4>Calendar colour :</h4>
                      </div>
                      <div class="col-md-10">
                        <div class="color-selectors">
                          <div v-for="color in colors" :key="color" class="color-field" :style="{ backgroundColor: color }" @click="handleColorSelect(color)">
                            <span v-if="form.calendar_colour === color" class="checkmark">✔</span>
                          </div>
                        </div>
                      </div>
                    </div> -->
                    </div>
                    <div class="submit-button text-end">
                      <router-link class="btn btn-light" to="/users/users-list">
                        Back</router-link>
                      <button type="submit" class="btn btn-primary">{{ isEditing ? 'Update' : 'Create and send invite'
                      }}</button>
                    </div>
                  </Form>
                </div>
              </div>
              <!-- /Company Settings -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-else-if="showFallback && isEditing">
        <div class="col-md-12">
            <no-data-found />
        </div>
</div>
</template>

<script>
import {
  ref,
  watch,
  onMounted,
  computed,
} from "vue";
import apiClient from "@/axios";
import {
  mapGetters,
  useStore
} from "vuex";
import {
  useRoute,
  useRouter
} from 'vue-router';
import Multiselect from 'vue-multiselect';
import $ from 'jquery';

import {
  Form,
  Field,
  ErrorMessage,
  useForm
} from "vee-validate";
import * as Yup from "yup";
import { message } from "ant-design-vue";
import { changeFormate } from "@/util";
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  data() {
    return {
      title: "Settings",
      availStatus: [
        'No', 'Yes'
      ],
      loginSmsCode: ['always'],
      dateFormat: "dd/MM/yyyy",
    }
  },
  computed: {
    ...mapGetters('auth', ['user']), // 'auth' is the namespace of your Vuex module
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const colors = ["#a8729f", "#8479b2", "#5190b0", "#66a8a7", "#58a677", "#97ab67", "#b4a775", "#a1867f", "#ba8970", "#db919c"];
    const imagePreview = ref('');
    const responsibleUsers = ref([]);
    const isEditing = ref(false);
    const showFallback = ref(false);
    const userData = ref({})
    if (route.query.userId) {
      // isCreatingUser.value = false;
      isEditing.value = true;
    }

    // const territories = computed(() => store.getters['users/getterritories']);

    const territories = ref([])

    const roles = ref([]);
    const permissionArray = ref([]);
    const selectedterritories = ref([]);
    const apiErrors = ref(null);

    let schema;

    if (isEditing.value) {
      schema = Yup.object().shape({
        first_name: Yup.string()
          .required("First name is required")
          .trim(),
        // .min(1, "First name must be at least 1 characters"),
        email: Yup.string()
          .required("Email is required")
          .email('The email field must be a valid email address.'),
        // role: Yup.string().required('Access level is required.'),
        roles_data: Yup.array().of(
          Yup.object().shape({
            role: Yup.string().required('Access level is required.'),
            territory_ids: Yup.mixed()
              .test(
                'is-valid-territory',
                'Please select at least one territory.',
                (value) => {
                  if (Array.isArray(value)) {
                    return value.length > 0;
                  }
                  return !!value; // if it's an object, check it's not null/undefined
                }
              )
              .required('Territory is required.')
          })
        ),
        outside_access_start: Yup.date().when("outside_access", (outside_access, schema) => {
          return outside_access === 1 ? schema.required("Start date is required") : schema;
        }),

        // ✅ Ensure `outside_access_end` is required if `outside_access === 1`
        outside_access_end: Yup.date()
          .when("outside_access", (outside_access, schema) => {
            return outside_access === 1 ? schema.required("End date is required") : schema;
          })
          .test("is-greater-or-equal", "End date must be greater or equal than start date", function (value) {
            const { outside_access_start } = this.parent;
            return !outside_access_start || !value || new Date(value) >= new Date(outside_access_start);
          }),
        allowed_mpan_api_calls: Yup.number()
          .nullable()
          .integer('Allowed MPAN API Calls must be an integer')
          .min(0, 'Allowed MPAN API Calls must be 0 or greater')
          .transform((value, originalValue) => {
            // Transform empty string to null
            return originalValue === '' ? null : value;
          }),
      });
    } else {
      schema = Yup.object().shape({
        first_name: Yup.string()
          .required("First name is required")
          .trim(),
        // .min(1, "First name must be at least 3 characters"),
        email: Yup.string()
          .required("Email is required")
          .email('The email field must be a valid email address.'),
        // role: Yup.string().required('Access level is required.'),
        roles_data: Yup.array().of(
          Yup.object().shape({
            role: Yup.string().required('Access level is required.'),
            territory_ids: Yup.mixed()
              .test(
                'is-valid-territory',
                'Please select at least one territory.',
                (value) => {
                  if (Array.isArray(value)) {
                    return value.length > 0;
                  }
                  return !!value; // if it's an object, check it's not null/undefined
                }
              )
              .required('Territory is required.')
          })
        ),
        password: Yup.string()
          .required('Please enter the password')
          .min(8, 'Password must be at least 8 characters')
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
            'Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character'
          ),
        password_confirmation: Yup.string()
          .required('Confirm Password is required')
          .oneOf([Yup.ref('password'), null], 'Password must match'),
        // outside_access: Yup.number().oneOf([0, 1]).notRequired(),
        outside_access_start: Yup.date().when("outside_access", (outside_access, schema) => {
          return outside_access === 1 ? schema.required("Start date is required") : schema;
        }),

        // ✅ Ensure `outside_access_end` is required if `outside_access === 1`
        outside_access_end: Yup.date()
          .when("outside_access", (outside_access, schema) => {
            return outside_access === 1 ? schema.required("End date is required") : schema;
          })
          .test("is-greater-or-equal", "End date must be greater or equal than start date", function (value) {
            const { outside_access_start } = this.parent;
            return !outside_access_start || !value || new Date(value) >= new Date(outside_access_start);
          }),
        allowed_mpan_api_calls: Yup.number()
          .nullable()
          .integer('Allowed MPAN API Calls must be an integer')
          .min(0, 'Allowed MPAN API Calls must be 0 or greater')
          .transform((value, originalValue) => {
            // Transform empty string to null
            return originalValue === '' ? null : value;
          }),
      });
    }

    const form = ref({
      id: null,
      image: null,
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      password: '',
      password_confirmation: '',
      // role: '',
      permissions: [],
      // territories: [],
      calendar_colour: "",
      initials: '',
      login_name: '',
      telephone: '',
      // organization_2nd_responsible: '',
      meter_opportunity_referred_by: '',
      use_available_status: '',
      login_by_sms_code: '',
      title: '',
      outside_access: 0,
      outside_access_start: null,
      outside_access_end: null,
      allowed_mpan_api_calls: 0,
      roles_data: [
        {
          role: "",
          territory_ids: [

          ],
          assigned_manager: ""
        },
      ]
    });
    // Function to calculate expiry date
    const allSelected = computed(() => {
      return (
        permissionArray.value.length > 0 &&
        permissionArray.value.every((permission) =>
          form.value.permissions.includes(permission.name)
        )
      );
    });

    const toggleSelectAll = () => {
      if (allSelected.value) {
        // Deselect all
        form.value.permissions = [];
      } else {
        // Select all
        form.value.permissions = permissionArray.value.map(
          (permission) => permission.name
        );
      }
    };
    // const isMultiple = computed(() => form.value.role === 'territory_manager' || form.value.role === 'cm_responsible');

    // Assuming form is a reactive object
    const formattedTelephone = computed({
      get() {
        // Ensure form and form.value.telephone are defined
        if (!form.value || !form.value.phone_number) {
          return ''; // Return an empty string if there's no telephone number
        }

        const number = form.value.phone_number.replace(/\D/g, '');

        // Check if the number is valid (e.g., 10 digits)
        if (number.length === 10) {
          // Format the number
          return `(${number.substring(0, 3)}) ${number.substring(3, 6)}-${number.substring(6)}`;
        } else {
          // Return the original value if the number is not valid
          return form.value.phone_number;
        }
      },
      set(value) {
        // Clean the input value to store only digits
        const cleanedValue = value.replace(/\D/g, '');

        // If the cleaned value is empty, set form.telephone to an empty string
        form.value.phone_number = cleanedValue.length ? cleanedValue : '';
      }
    });

    const fetchUserData = async (id) => {
      try {
        const response = await apiClient.get(`/company/users/view/${id}`);
        userData.value = response?.data
        Object.assign(form.value, response.data);
        imagePreview.value = response.data.image;
        if (response.data.permissions.length && !isEditing.value) {
          form.value.permissions = permissionArray.value.map(
            (permission) => permission.name
          );
        }
        if (response.data.outside_access_start) {
          form.value.outside_access_start = new Date(response.data.outside_access_start)
        }
        if (response.data.outside_access_end) {
          form.value.outside_access_end = new Date(response.data.outside_access_end)
        }
        // if (response.data.territories) {
        //   if (isMultiple.value) {
        //     form.value.territories = territories.value.filter(territory =>
        //       response.data.territories.includes(territory.id)
        //     );
        //   } else {
        //     // If single selection is allowed, find and set the single territory
        //     const selectedTerritory = territories.value.find(territory =>
        //       response.data.territories.includes(territory.id)
        //     );
        //     form.value.territories = selectedTerritory ? selectedTerritory : null;
        //   }
        // }


        if (response.data.roles_data.length) {
          // Expand each (role, territory_id) pair into its own row so UI shows one row per territory.
          // This fixes the "1 role + 2 territories still shows 1 row" issue.
          const expanded = response.data.roles_data.flatMap((role) => {
            const ids = Array.isArray(role.territory_ids) ? role.territory_ids : [];
            if (!ids.length) {
              return [{
                ...role,
                territory_ids: null,
              }];
            }

            // If role is allowed multiple territories (territory_manager / cm_responsible),
            // keep the existing multi-select behaviour (single row).
            const allowMultiple = role.role === 'territory_manager' || role.role === 'cm_responsible';
            if (allowMultiple) {
              return [{
                ...role,
                territory_ids: territories.value.filter((t) => ids.includes(t.id)),
              }];
            }

            // Otherwise show one row per territory.
            return ids.map((territoryId) => ({
              ...role,
              territory_ids: territories.value.find((t) => t.id === territoryId) || null,
            }));
          });

          form.value.roles_data = expanded;

          form.value.roles_data.forEach((_, index) => {
            fetchResponsibles('', index);
          });
        } else {
          form.value.roles_data = [
            {
              role: "",
              territory_ids: [

              ],
              assigned_manager: ""
            },
          ]
        }

        if (response.data.calendar_colour) {
          form.value.calendar_colour = response.data.calendar_colour;
        }
        // Ensure allowed_mpan_api_calls defaults to 0 if not provided or null
        if (response.data.allowed_mpan_api_calls === null || response.data.allowed_mpan_api_calls === undefined) {
          form.value.allowed_mpan_api_calls = 0;
        }
      } catch (error) {
        showFallback.value = true;
        console.error('Error fetching user data:', error);
      }
    };
    const registerUser = async () => {
      let isValid = true;
      $('.error-message').remove();

      if (form.value.id) {
        if (form.value.password.length > 0) {
          if (form.value.password !== form.value.password_confirmation) {
            isValid = false;
            $('#password_confirmation').after('<span class="text-danger error-message">Password must match</span>');
          }
        }
      }
      if (!isValid) {
        return;
      }
      
      // let selectedTerritoryIds = [];

      // const allTerritoryIds = form.value.roles_data.flatMap(role => role.territory_ids)

      // const uniqueTerritoryIds = new Set(allTerritoryIds)

      // if (allTerritoryIds.length !== uniqueTerritoryIds.size) {
      //   message.error('A user may only be assigned a single access level with an associated territory.')
      //   return;
      // }

      // if (isMultiple.value) {
      //   selectedTerritoryIds = form.value.territories.map((territory) => territory.id);
      // } else if (form.value.territories && form.value.territories.id) {
      //   selectedTerritoryIds = [form.value.territories.id];
      // } 
      const payload = {
        ...form.value,
        roles_data: form.value.roles_data.map(role => ({
          ...role,
          territory_ids: Array.isArray(role.territory_ids)
            ? role.territory_ids.map(territory => territory.id)
            : role.territory_ids?.id ? [role.territory_ids.id] : []
        })),
        // Ensure allowed_mpan_api_calls is always a number (default to 0 if null/undefined)
        allowed_mpan_api_calls: form.value.allowed_mpan_api_calls !== null && form.value.allowed_mpan_api_calls !== undefined 
          ? Number(form.value.allowed_mpan_api_calls) 
          : 0
      }

      const outside_access_start = changeFormate(form.value.outside_access_start)
      const outside_access_end = changeFormate(form.value.outside_access_end)
      const data = await store.dispatch("users/createUser", {
        // ...form.value,
        ...payload,
        // territories: selectedTerritoryIds,
        outside_access_start: outside_access_start,
        outside_access_end: outside_access_end
      });
      if (data.status === 200) {
        message.success(data?.data?.message)
        router.push('/users/users-list');
      } else if (!data.status) {
        message.error(data?.errors?.message)
        apiErrors.value = data.errors?.errors;
      } else if (data.status === 500) {
        message.error(data?.errors?.message);
        apiErrors.value = data.errors?.errors;

      }
    };
   const allTerritoryIds = computed(() =>
  territories.value.map(t => t.id)
);

const selectedTerritoryIds = computed(() => {
  const ids = form.value.roles_data.flatMap((role) => {
    const v = role.territory_ids;
    if (Array.isArray(v)) return v.map((t) => (typeof t === 'object' ? t.id : t)).filter(Boolean);
    if (v && typeof v === 'object') return v.id ? [v.id] : [];
    return v ? [v] : [];
  });
  return [...new Set(ids)];
});

const canAddRole = computed(() => {
  return selectedTerritoryIds.value.length < allTerritoryIds.value.length;
});
    const handleImageUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        form.value.image = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          imagePreview.value = e.target.result; // Show the image preview
        };
        reader.readAsDataURL(file); // Convert the file to a data URL
      }
    };

    const removeImage = () => {
      form.value.image = '';
      imagePreview.value = '';
    };

    const handleColorSelect = (color) => {
      form.value.calendar_colour = color;
    };
    const fetchRoles = async () => {
      try {
        const response = await apiClient.get('/company/user/roles');
        roles.value = response.data.map(role => {
          const [key, value] = Object.entries(role)[0];
          return {
            key,
            value
          };
        });
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    };

    const fetchPermissions = async () => {
      try {
        const data = await store.dispatch("users/fetchUserPermissions");
        permissionArray.value = data.permissions || [];
        // Initialize the permissions if the form.permissions is empty
        if (!form.value.permissions.length && !isEditing.value) {
          form.value.permissions = permissionArray.value.map(
            (permission) => permission.name
          );
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    const fetchResponsibles = async (role, index) => {
      if (role === 'role') {
        // form.value.territories = [];
        form.value.roles_data[index].territory_ids = []
      }

      // const selectedRole = form.value.role;
      const selectedRole = form.value.roles_data[index].role;
      let selectedTerritory_Ids = [];
      // const selectedTer = form.value.territories;
      const selectedTer = form.value.roles_data[index].territory_ids;

      // Determine if multiple selections are allowed
      if (Array.isArray(selectedTer)) {
        selectedTerritory_Ids = selectedTer.map(territory => territory.id);
      } else if (selectedTer && selectedTer.id) {
        selectedTerritory_Ids = [selectedTer.id];
      }

      if (selectedRole !== '') {
        try {
          const response = await apiClient.get('/dropdown/company/assigned-managers', {
            params: {
              role: selectedRole,
              territory_ids: selectedTerritory_Ids.length > 0 ? selectedTerritory_Ids : []
            }
          });
          responsibleUsers.value[index] = response.data.map(user => ({
            id: user.id,
            name: `${user.first_name} ${user.last_name || ''}`
          }));
        } catch (error) {
          console.error('Error fetching roles:', error);
        }
      }
    };

    const handleChange = () => {
      form.value.outside_access_start = null
      form.value.outside_access_end = null
    }

    const addRole = () => {
      form.value.roles_data.push({
        role: '',
        territory_ids: [],
        assigned_manager: '',
      })
    }

    const removeRole = (index) => {
      form.value.roles_data.splice(index, 1)
    }

    const handleInitials = () => {
      form.value.initials = form.value.first_name.charAt(0) + form.value.last_name.charAt(0)
    }

    const getAvailableTerritories = (currentIndex) => {
      const selectedIds = form.value.roles_data
        .filter((_, index) => index !== currentIndex) // Exclude current row
        .flatMap(role => role.territory_ids || [])     // Flatten all selected territories
        .map(t => typeof t === 'object' ? t.id : t);    // Handle object vs. id
      return territories.value.filter(t => !selectedIds.includes(t.id));
    };
    onMounted(async () => {
      fetchPermissions();
      const userId = route.query.userId;
      const data = await store.dispatch('users/fetchTerritories');
      territories.value = data;
      // fetchTerritories();
      fetchRoles();
      if (userId) {
        fetchUserData(userId);
      }
      // fetchResponsibles();
    });

    return {
      getAvailableTerritories,
      allTerritoryIds,
      canAddRole,
      schema,
      isEditing,
      formattedTelephone,
      imagePreview,
      roles,
      responsibleUsers,
      fetchPermissions,
      permissionArray,
      allSelected,
      toggleSelectAll,
      territories,
      removeImage,
      selectedterritories,
      form,
      registerUser,
      fetchResponsibles,
      colors,
      handleColorSelect,
      handleImageUpload,
      // isMultiple,
      apiErrors,
      handleChange,
      addRole,
      removeRole,
      handleInitials,
      showFallback,
      userData
    };
  },
};
</script>

<style>
.profile-upload-img {
  width: 150px;
  height: 150px;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.color-selectors {
  display: flex;
  gap: 10px;
}

.color-field {
  width: 30px;
  height: 30px;
  cursor: pointer;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
  transition: border-color 0.3s;
}

.color-field:hover {
  border-color: #ccc;
}

.color-field .checkmark {
  font-size: 20px;
  color: white;
}

.color-field.selected {
  border-color: #000;
}

.cross-btn {
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #fc0027;
}
</style>
